import { Ellipsis } from "lucide-react";
import React from "react";

import { IgIconButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { WidgetDto } from "@intelligems/ig-types";
import { Grid, SxProps } from "@mui/material";
import { useDispatch } from "@src/store";
import { editWidget } from "@src/store/slices/widgets";

interface QuantityButtonsWidgetPreviewProps {
  widget: WidgetDto;
  library?: boolean;
  children?: React.ReactNode;
  isEdit?: boolean;
}

export const QuantityButtonsWidgetPreview = ({
  widget,
  children,
  isEdit,
}: QuantityButtonsWidgetPreviewProps) => {
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(editWidget(widget));
  };

  return (
    <Grid item xs={12} md={12} lg={4} key={widget.id} display={"inline-flex"}>
      <IgPaper
        sx={
          isEdit
            ? {}
            : { padding: "16px !important", width: "100%", maxWidth: "381px" }
        }
      >
        <Grid container direction={"column"} rowSpacing={5}>
          <Grid
            item
            justifyContent={"space-between"}
            container
            alignItems={"center"}
            direction={"row"}
            wrap={"nowrap"}
          >
            <Grid item xs={4}>
              <IgTypography
                variant={isEdit ? "h3" : "body1"}
                fontWeight={400}
                noWrap
              >
                {isEdit ? "Preview" : widget.name}
              </IgTypography>
            </Grid>
            {isEdit ? null : (
              <Grid item>
                <IgIconButton size={"small"} iconSize={16} onClick={handleEdit}>
                  <Ellipsis />
                </IgIconButton>
              </Grid>
            )}
          </Grid>
          <Grid
            item
            container
            direction={"column"}
            justifyContent={"space-between"}
            rowSpacing={5}
            alignItems={"center"}
          >
            {children}
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
